export default __webpack_public_path__ + "static/media/content-copy.04c12938.svg";